import { Flex, Box, Text, Spinner, Center } from '@chakra-ui/react';
import { Icon } from 'src/components/atoms/Icon';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from 'src/contexts/AppContext';
import { InboxItem, useUpdateMessageMutation } from 'src/api/inboxes';
import { useCustomToast } from 'src/hooks/useCustomToast';

type InboxDetailsHeaderProps = {
  message: InboxItem;
};

export const InboxDetailsHeader = (props: InboxDetailsHeaderProps) => {
  const { message } = props;
  const { showError } = useCustomToast();
  const navigate = useNavigate();
  const { currentCustomer } = useAppContext();
  const { mutate: updateMessage, isLoading: isUpdatingMessage } =
    useUpdateMessageMutation(
      currentCustomer?.customerName ?? 'missing_customer',
      message.id,
    );

  const onBack = () => {
    navigate('/inbox');
  };

  const onDelete = () => {
    updateMessage(
      { isTrash: true },
      {
        onSuccess: () => {
          navigate('/inbox');
        },
        onError: (error) => {
          // eslint-disable-next-line no-console
          console.error('Error deleting message:', error);
          showError(
            'Error deleting message',
            'There was an error deleting the message',
          );
        },
      },
    );
  };

  if (isUpdatingMessage) {
    return (
      <Center w="100%" h="100%">
        <Spinner speed="0.8s" size="xl" thickness="4px" />
      </Center>
    );
  }
  return (
    <Flex justifyContent="space-between" alignItems="center">
      <Flex gap={4}>
        <Icon
          iconName="arrow-back"
          h={6}
          w={6}
          onClick={onBack}
          _hover={{ cursor: 'pointer' }}
        />
        <Icon
          iconName="delete"
          h={5}
          w={5}
          onClick={onDelete}
          _hover={{ cursor: 'pointer' }}
        />
      </Flex>
      <Flex gap={4}>
        <Text color="text.title">1 out of 20</Text>
        <Box>
          <Icon iconName="chevron-left" />
          <Icon iconName="chevron-right" />
        </Box>
      </Flex>
    </Flex>
  );
};
